import React from "react";
import ContentBox from "../../components/molecules/ContentBox.Component";
import ImageSvg from "../../components/atoms/ImageSVG";
import { HashLink } from "react-router-hash-link";

const ProjectsDesktop = ({ lang, title, projects, tags }) => {
  return (
    <div className="min-h-[1600px] bg-cover bg-center bg-no-repeat overflow-x-hidden">
      <div className="flex justify-center relative z-10">
        <div className="w-2/3 px-10 pt-24 pb-20">
          <div data-aos="fade-right" data-aos-delay={200}>
            <ContentBox
              tags={tags[lang]}
              title={{
                value: title.value[lang],
                style: "text-dark font-bold text-5xl 2xl:text-6xl",
              }}
              par={{ value: "", style: "" }}
            />
          </div>

          <div className="mt-10 flex flex-col gap-6">
            {projects.map((project, index) => (
              <article
                key={index}
                data-aos="fade-up"
                data-aos-delay={100 * index}
                className="flex bg-[#eee] rounded-2xl overflow-hidden shadow-lg transition-shadow duration-300 ease-in-out hover:shadow-2xl"
              >
                <div
                  className="w-48 2xl:w-64 flex-shrink-0 flex justify-center items-center bg-dark bg-no-repeat bg-cover bg-center"
                  style={{ backgroundImage: `url(${project.media.src})` }}
                  title={project.media.title}
                  role="img"
                  aria-label={project.media.alt}
                >
                  <ImageSvg
                    type={project.logo}
                    fill={"#f6f6f6"}
                    stroke={"#f6f6f6"}
                    width={"45%"}
                  />
                </div>

                <div className="flex-1 p-7 2xl:p-8">
                  <div className="flex justify-between items-start gap-6">
                    <h3 className="text-2xl font-bold text-dark">
                      {project.title.value[lang]}
                    </h3>
                    {project.button ? (
                      <HashLink
                        to={project.button.href}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={project.title.value[lang]}
                        className="flex-shrink-0"
                      >
                        <p className="w-fit cursor-pointer bg-light px-4 py-1 rounded shadow-xl transition-all duration-300 ease-in-out hover:bg-blue-500 hover:text-light hover:fill-[#f6f6f6]">
                          <span className="text-lg">
                            {project.button.value[lang]}
                          </span>
                          <span className="float-right relative top-1.5 ml-3">
                            <ImageSvg type="east" width={25} />
                          </span>
                        </p>
                      </HashLink>
                    ) : null}
                  </div>

                  {project.tags && project.tags[lang].length ? (
                    <div className="mt-2 flex flex-wrap gap-2">
                      {project.tags[lang].map((tag, i) => (
                        <span
                          key={i}
                          className="bg-dark text-light text-xs font-bold capitalize px-3 py-1 rounded"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  ) : null}

                  <p className="mt-3 text-sm leading-relaxed text-dark-33">
                    {project.par.value[lang]}
                  </p>

                  {project.par.list ? (
                    <ol className="list-decimal ml-5 mt-3 font-semibold">
                      {project.par.list.value[lang].map((list, i) => (
                        <li key={i} role="region" className="text-sm py-0.5">
                          {list}
                        </li>
                      ))}
                    </ol>
                  ) : null}
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsDesktop;
